var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class LoginState {
    constructor(url) {
        this.url = url;
    }
    static setBodyData(loggedIn) {
        document.body.dataset.portalLoggedIn = loggedIn;
    }
    getStatus() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const key = 'portal-logged-in';
            LoginState.setBodyData((_a = localStorage.getItem(key)) !== null && _a !== void 0 ? _a : 'false');
            const apiStatus = yield this.getApiLoginStatus();
            LoginState.setBodyData(apiStatus);
            localStorage.setItem(key, apiStatus);
        });
    }
    getApiLoginStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield fetch(this.url, {
                method: 'GET',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                return String(data.loggedin);
            })
                .catch(() => {
                return 'false';
            });
        });
    }
}
// tslint:disable-next-line:no-any
const portalLoginState = window.PortalLoginState;
new LoginState(portalLoginState.ajax.url).getStatus();
